import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class CheckoutStepsService {

  constructor(
    private router: Router
  ) { }

  verifyData(requestedStep: number, allowedStep: number) {
    if (allowedStep < requestedStep) {
      let redirectUrl;
      switch (allowedStep) {
        case 1:
          redirectUrl = 'checkout/address';
          break;
        case 2:
          redirectUrl = 'checkout/shipping';
          break;
        case 3:
          redirectUrl = 'checkout/review';
          break;
        case 4:
          redirectUrl = 'checkout/done';
          break;
      }
      this.router.navigate([redirectUrl]);
    }
  }
}
